
import { License } from "@/lib/types"

interface LicenseStatusBadgeProps {
  license: License
}

export function LicenseStatusBadge({ license }: LicenseStatusBadgeProps) {
  const isExpired = new Date(license.expiresAt) < new Date()
  
  if (license.isRevoked) {
    return (
      <div className="flex items-center gap-2">
        <span className="h-2 w-2 rounded-full bg-red-500" />
        <span className="text-muted-foreground">Revoked</span>
      </div>
    )
  }
  
  if (isExpired) {
    return (
      <div className="flex items-center gap-2">
        <span className="h-2 w-2 rounded-full bg-amber-500" />
        <span className="text-muted-foreground">Expired</span>
      </div>
    )
  }
  
  return (
    <div className="flex items-center gap-2">
      <span className="h-2 w-2 rounded-full bg-emerald-500" />
      <span className="text-foreground font-medium">Active</span>
    </div>
  )
}
